import { EmailJSResponseStatus } from '../models/EmailJSResponseStatus';
import { store } from '../store/store';
export const sendPost = async function (url, data) {
  let headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const response = await fetch(store.origin + url, {
    method: 'POST',
    headers,
    body: data
  });
  const message = await response.text();
  const responseStatus = new EmailJSResponseStatus(response.status, message);
  if (response.ok) {
    return responseStatus;
  }
  throw responseStatus;
};